import React from 'react';
import { Box } from '@mui/material';
import { HeroVideoPlayer } from '../HeroVideoPlayer';
import { HeroVideo } from '../../types';
import { VideoItem } from '../VideoCarousel/VideoCarouselModal';
import { HeroVideoPicker } from './HeroVideoPicker';

interface HeroVideoContentProps {
  heroVideo: HeroVideo | null;
  heroVideoSearchQuery: string;
  heroVideoSearchResults: VideoItem[];
  isSearchingHeroVideo: boolean;
  isPreviewPlaying: boolean;
  actualVideoDuration: number | null;
  videoRef: React.RefObject<HTMLVideoElement>;
  videoUrl: string;
  onSearchQueryChange: (query: string) => void;
  onSelectVideo: (video: VideoItem) => void;
  onRemove: () => void;
  onPausePreview: () => void;
  onPlayPreview: () => void;
  onLoopRangeChange: (event: Event, newValue: number | number[]) => void;
  onVideoTimeUpdate: () => void;
  onLoadedMetadata: () => void;
  onEnded: () => void;
  getEffectiveDuration: () => number;
}

export function HeroVideoContent({
  heroVideo,
  heroVideoSearchQuery,
  heroVideoSearchResults,
  isSearchingHeroVideo,
  isPreviewPlaying,
  actualVideoDuration,
  videoRef,
  videoUrl,
  onSearchQueryChange,
  onSelectVideo,
  onRemove,
  onPausePreview,
  onPlayPreview,
  onLoopRangeChange,
  onVideoTimeUpdate,
  onLoadedMetadata,
  onEnded,
  getEffectiveDuration,
}: HeroVideoContentProps) {
  if (heroVideo) {
    return (
      <HeroVideoPlayer
        heroVideo={heroVideo}
        videoRef={videoRef}
        videoUrl={videoUrl}
        isPreviewPlaying={isPreviewPlaying}
        actualVideoDuration={actualVideoDuration}
        onRemove={onRemove}
        onPausePreview={onPausePreview}
        onPlayPreview={onPlayPreview}
        onLoopRangeChange={onLoopRangeChange}
        onVideoTimeUpdate={onVideoTimeUpdate}
        onLoadedMetadata={onLoadedMetadata}
        onEnded={onEnded}
        getEffectiveDuration={getEffectiveDuration}
      />
    );
  }

  return (
    <Box>
      <HeroVideoPicker
        searchQuery={heroVideoSearchQuery}
        searchResults={heroVideoSearchResults}
        isSearching={isSearchingHeroVideo}
        onSearchQueryChange={onSearchQueryChange}
        onSelectVideo={onSelectVideo}
      />
    </Box>
  );
}
